import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from '@apollo/client/react/hoc';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { itemQuery } from '../../../../queries';
import NumberField from '../../common/NumberField';
import {
  setIsLoadingResultByNumber,
  setResultByNumber
} from '../../../../actions';
import { useDebounce } from '../../../../hooks/useDebounce';

const NewSearchAdNumber = ({ client }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [query, setQuery] = useState('');

  const debouncedQuery = useDebounce(query, 500);

  const resetResult = () => {
    dispatch(setResultByNumber({ hasAnyResult: false, result: null }));
  };

  const resetValue = () => {
    setQuery('');
    resetResult();
  };

  useEffect(() => {
    if (query.length >= 5 && query.length <= 10) {
      (async function fetchData() {
        dispatch(setIsLoadingResultByNumber(true));
        return client
          .query({
            query: itemQuery(query),
            variables: { id: query }
          })
          .then(response => {
            dispatch(
              setResultByNumber({
                hasAnyResult: true,
                result: response.data.item
              })
            );
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            dispatch(setIsLoadingResultByNumber(false));
          });
      })();
    } else {
      resetResult();
    }
  }, [debouncedQuery]);

  return (
    <div
      className="filters__section filters__last-block filters__section_ad-number"
      data-stat="new-search-form-ad-number"
    >
      <NumberField
        id="search-form-search-by-number"
        name="ad_number"
        floatingPlaceholder={t('new_search.search_by_id')}
        fieldValue={query}
        onChange={setQuery}
        onReset={resetValue}
        wrapperClassName="filters__field-wrapper_full-width"
      />
    </div>
  );
};

NewSearchAdNumber.propTypes = {
  t: PropTypes.func,
  client: PropTypes.object
};

export default withApollo(NewSearchAdNumber);
